import styled from 'styled-components';

import { mediaBreakpoint } from '../utils/mediaBreakpoint';

type props = {
  showBorder?: boolean;
}

const SubHeadingMobileOnly = styled.h3<props>`
  &&& {
    border: ${({ theme, showBorder }) => (
        showBorder
            ? `1px solid ${theme.Colors.Aliases.textLightSecondary}`
            : 0
    )};
    ${({ theme }) => theme.TextStyles.span.Text20EmphasisLeft};
    margin: ${({ theme }) =>
        `${theme.Spacing.spacing0x}`};
   padding: ${({ theme, showBorder }) => (
        showBorder
            ? `${theme.Spacing.spacing3x}`
            : 0
    )};
    ${mediaBreakpoint.up('md')} {
        display: none;
    }
  }
`;

export default SubHeadingMobileOnly;
